<template>

<div>
    
  <div data-role="header" class="border-bottom ui-bar-a ui-header" role="banner">
    <h1 class="logoimg ui-title" tabindex="0" role="heading" aria-level="1"><a href="javascript:;" rel="external" class="ui-link"><img src="images/menulogo.jpg" alt="menu"></a></h1>
  </div>

  <div data-role="footer" class="border-top ui-bar-a ui-footer" id="home-footer" role="contentinfo">
     <div data-role="navbar" class="ui-navbar ui-navbar-noicons" role="navigation">
        <ul class="ui-grid-solo">
           <!--<li><a href="tel:+32471258107" rel="external"><img src="images/call.png"><br />Peter</a></li>-->
           <li class="ui-block-a"><a href="mailto:support@nutportal.com" rel="external" data-theme="a" class="ui-btn ui-btn-up-a"><span class="ui-btn-inner"><span class="ui-btn-text"><img src="images/email.png"><br>Support E-mail</span></span></a></li>
           <!--<li><a href="tel:+3232830618" rel="external"><img src="images/call.png"><br />Office</a></li>-->
        </ul>
     </div>
  </div>


      <div data-role="page" id="home" >
        <div v-if="!!week" data-role="content" class="text-page ui-content">
            <div data-role="content" class="text-page ui-content" role="main">
              <h3>Week : {{week.title}}</h3>
              <p>Start : {{week.start}} - End : {{week.end}}</p>
              <p>Client : {{client.first_name}} {{client.last_name}}</p>
            </div>
        </div>
        <hr> 
        <div data-role="content" class="text-page ui-content" v-for="(menu,i) in menus">
            <div data-role="content" class="text-page ui-content">
              <div data-role="content" class="text-page " role="main">
                <h3>Menu Day : {{menu.day}} </h3>
                <h4>Date : {{getDatesBetweenDates(menu.day)}}</h4>
              </div>
          </div>
            <div data-role="content" class="text-page ui-content" role="main">
              <div v-if="menu.meals.length > 0" v-for="(meal,j) in menu.meals" data-role="collapsible" data-theme="c" data-content-theme="d" data-inset="false" data-collapsed-icon="arrow-r" data-expanded-icon="arrow-d" data-corners="false" data-collapsed="true" class="ui-collapsible-contain">
                  <h4 v-b-toggle="'collapse'+i+j" class="ui-collapsible-heading ui-collapsible-heading-collapsed">
                  <a href="javascript:;" style="text-decoration:none;" class="ui-collapsible-heading-toggle ui-btn ui-btn-icon-left ui-shadow ui-corner-all ui-btn-up-c" data-theme="c">
                  <span class="ui-btn-inner ui-corner-all"><span class="ui-btn-text">{{meal.type}}<span class="ui-collapsible-heading-status"> click to expand contents</span></span>
                  <span data-theme="d" class="ui-btn ui-btn-up-d ui-btn-icon-left ui-btn-corner-all ui-shadow"><span class="ui-btn-inner ui-btn-corner-all ui-corner-all">
                  <span class="ui-btn-text"></span><span class="ui-icon ui-icon-shadow ui-icon-plus"></span></span></span></span></a></h4>
                  
                  <b-collapse :id="'collapse'+i+j" class="mt-2">
                    <div class="ui-collapsible-content ui-collapsible-content" aria-hidden="true">
                      <b-row>
                        <b-col lg="12" style="margin-bottom:10px;">
                        <b-row>
                          <b-col lg="4"  md="7"> <strong>{{ $t('menu.meal') }} #{{i+1}} {{ meal.type }}</strong></b-col> 
                          <b-col lg="8"  md="5"> <b>{{ $t('menu.energy') }} : </b> <span> {{ meal.foods | totalCal }}</span></b-col> 
                        </b-row> 
                        <b-row>
                          <b-col lg="12">
                            <b-row v-for="(food, index) in meal.foods"  style="margin-bottom:5px;">                                    
                              <b-col lg="8"  md="5"> <b>{{ $t('menu.qty') }} : </b> {{food.qty}} ,  <b>{{ $t('menu.energy') }} : </b> {{food.energy_kc}} , <b>{{ $t('menu.serving') }} : </b>{{food.servingVal}} {{food.serving}}</b-col> 
                              <b-col lg="4"  md="7"> <b>{{i+1}}.</b> {{food.english_title}}  |  {{food.hebrew_title}} </b-col> 
                            </b-row> 
                          </b-col>
                        </b-row> 
                        </b-col>
                      </b-row> 
                    </div>
                  </b-collapse>
              </div>
            </div>
        </div>
      </div>

      <div class="ui-collapsible-content" aria-hidden="false">
        <ul data-role="listview" data-theme="d" class="ui-listview">
                        <li class="ui-li-has-icon ui-btn ui-btn-icon-right ui-li ui-btn-hover-d" data-theme="d"><div class="ui-btn-inner ui-li"><div class="ui-btn-text">
                        <a href="javascript:;" @click="email(created)" data-rel="dialog" rel="external" class="ui-link-inherit"><img src="images/b-email.png" class="ui-li-icon ui-corner-none ui-li-thumb"> VIA EMAIL</a>
        </div><span class="ui-icon ui-icon-arrow-r"></span></div></li>
        </ul>
      </div>
      <div data-role="footer" class="border-top ui-bar-a ui-footer" id="home-footer" role="contentinfo">
         <div data-role="navbar" data-theme="c" class="ui-navbar ui-navbar-noicons" role="navigation">
         </div>
         <!-- END data-role="navbar" -->
         <h4 class="ui-title" tabindex="0" role="heading" aria-level="1">© {{ new Date().getFullYear() }} NutHub</h4>
      </div>
      <ul data-role="listview" data-inset="false" data-theme="a" class="ui-listview">
         <li class="ui-li-has-icon ui-btn ui-btn-icon-right ui-li ui-btn-up-a" data-theme="a">
            <div class="ui-btn-inner ui-li">
               <div class="ui-btn-text"><a href="https://nutportal.com" rel="external" data-theme="a" class="ui-link-inherit"><img src="images/webw.png" class="ui-li-icon ui-corner-none ui-li-thumb">Create Your menu</a></div>
               <span class="ui-icon ui-icon-arrow-r"></span>
            </div>
         </li>
      </ul>

</div>
</template>

<script>

// import LineExample from './charts/LineExample';
import _ from 'lodash';
import moment from 'moment';
import Models from '@/store/ORM/models.js';
import WeekService from '@/services/week.service.js';

export default {
  name: 'dashboard',
  data: function () {
    return {
      menus : [],
      created : null,
      client : null,
      week : null,
      dates : [],
    }
  },
  methods: {
    getClientWeekly(week_id,client_id) {
      WeekService.getClientWeekly(week_id,client_id)
      .then((response) => {
          if(response.data.success){
            this.week = response.data.week;
            this.client = response.data.client;
            this.menus = response.data.menus;
            // this.getDates()
          }
        },err => {
        });
    },
    getDatesBetweenDates(day) {

        let startDate = new Date(this.week.start);
        let endDate = new Date(this.week.end);
        var days = parseInt(day);
        var date = new Date(startDate);

        date = date.setDate(date.getDate() + (days -1));
        const options = { weekday: 'long', year: "numeric", month: "long", day: "numeric" };
        let selected_date = (this.language == "en") ? new Date(date).toLocaleDateString("en-Us", options) : new Date(date).toLocaleDateString("he-IL", options);

        return selected_date;
    },
  },
  created() {
    this.getClientWeekly(this.$route.params.week_id,this.$route.params.client_id);
  },
  computed: {
    
    language() {
        this.selectedFoodType = null;
        return this.$store.getters['UserModules/getLanguage']
    }
  },
  filters:{
    totalCal : function(foods){
      let total = 0;

      foods.forEach((food)=>{
        if(!!food.energy_kc){
          total += food.energy_kc;
        }
      });

      return total;

    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  input:read-only:focus {
    outline-offset: 0px !important;
    outline: 0px !important;
  }
  .col{
    display:flex;
    align-items: center;
  }

  .ui-header,#home-footer,.ui-collapsible-content{
    margin: 0px 15px;
  }


  .ui-btn-up-c {
    font-family: 'Open Sans', sans-serif;
    border: 1px solid #111;
    background: #669933;
    font-weight: bold;
    color: #000;
    background-image: -webkit-gradient(linear, left top, left bottom, from(#669933), to(#a7c118));
    background-image: linear-gradient(#669933 , #a7c118);
}
    div.gallery-row:after { clear: both; content: "."; display: block; height: 0; visibility: hidden; }
    div.gallery-item {
  float: left;
  width: 50%;
}
    div.gallery-item a { display: block; margin: 5px; border: 1px solid #3c3c3c; }
    div.gallery-item img { display: block; width: 100%; height: auto; }
    #Gallery1 .ui-content, #Gallery2 .ui-content { overflow: hidden; }

    .ui-listview{
        margin: 0px 15px;
    }
</style>
